export default __webpack_public_path__ + "static/media/sc5.bdde32db.jpg";